import React from 'react';
import { Flex } from 'lib/components/styles/layout';
import { Line, UIKitCardSectionTitle } from './styles';

interface StyleObject {
  container?: React.CSSProperties;
}

interface IUIKitCardSectionProps {
  title: string;
  children: JSX.Element;
  extendStyles?: StyleObject;
}

export const UIKitCardSection = ({
  title,
  children,
  extendStyles,
}: IUIKitCardSectionProps) => {
  return (
    <Flex
      flexDirection='column'
      gap='16px'
      style={{ ...extendStyles?.container }}
    >
      <Flex flexDirection='row' gap='12px' alignItems='center'>
        <UIKitCardSectionTitle>{title}</UIKitCardSectionTitle>
        <Line />
      </Flex>
      {children}
    </Flex>
  );
};
